module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-40.28eb26ad.svg";